<!-- DKM-1078 Cedric: eski hâli (aşağıda yorum içinde). Kaldırılanlar: yeni kayıtta anlamsız salt-okunur üst form
     (Kod/Durum/Atanan/Liste No/Kayıt No), "Birim" alanının BasvuruKullaniciKod'a bağlı olması, e-posta/SMS seçimi
     (bildirim Faz 4). Başvuran, birim ve durum sunucuda oturumdan dolar.
<div class="default-card">
  <dx-form 
  [(formData)]="helpdeskForm"
    [readOnly]="true"
  >
<dxi-item
    [label]="{ text: 'Kod' }" dataField="Kod"
  >
  </dxi-item>
  <dxi-item
    [label]="{ text: 'Başvuru Durum' }"  dataField="BasvuruDurum"
  >
    <div *dxTemplate>
      <dk-ct-gen-lookup
        [validationRules]="validationRulesMap['BasvuruDurum']"
        [placeholder]="'Başvuru Durum'"
        [selectedValue]="helpdeskForm?.BasvuruDurum"
        (valueChange)="helpdeskForm.BasvuruDurum = $event.value"
        [readOnly]="true"
        [lookUpType]="'HLP_BASVURU_DURUM_TUR'"
        [labelMode]="labelMode"
        [label]="'Başvuru Durum'"
      ></dk-ct-gen-lookup>
    </div>
  </dxi-item>
  <dxi-item
    [label]="{ text: 'Atanan Kullanıcı' }" dataField="AtananKullaniciKod"
  >
    <div *dxTemplate>
      <dk-ctl-gen-kontrol
              #control
        [labelText]="'Atanan Kullanıcı'"
        [code]="helpdeskForm?.AtananKullaniciKod"
        [validationRulesMap]="validationRulesMap['AtananKullaniciKod']"
        [controlName]="'vIkaPersonel'"
        (dataResult)="helpdeskForm.AtananKullaniciKod = $event.Kod"
        [labelMode]="labelMode"
        [isReadOnly]="true"
      ></dk-ctl-gen-kontrol>
    </div>
  </dxi-item>
  <dxi-item
    [label]="{ text: 'Liste No' }" dataField="DlistId"
  >
    <div *dxTemplate>
      <dk-ctl-gen-kontrol
              #control


        [labelText]="'Liste No'"
        [code]="helpdeskForm?.DlistId"
        [validationRulesMap]="validationRulesMap['DlistId']"
        [controlName]="'GenDlist'"
        (dataResult)="helpdeskForm.DlistId = $event.Kod"
        [labelMode]="labelMode"
        [isReadOnly]="true"
      ></dk-ctl-gen-kontrol>
    </div>
  </dxi-item>
  <dxi-item
    [label]="{ text: 'Kayıt No' }" dataField="KayitNo"
  >
  </dxi-item>
  </dx-form>
  
</div>

<dx-form
  id="form"
  [(formData)]="helpdeskForm"
  [colCount]="1"
  [showColonAfterLabel]="true"
  [labelMode]="labelMode"
  [labelLocation]="labelLocation"
>
  <dxi-item
    dataField="BasvuruKullaniciKod"
    [label]="{ text: 'Kullanıcı' }"
    [editorOptions]="{
        readOnly: true,
      }"
  >
    <div *dxTemplate>
      <dk-ctl-gen-kontrol
              #control

        [labelText]="'Kullanıcı'"
        [code]="helpdeskForm?.BasvuruKullaniciKod"
        [validationRulesMap]="validationRulesMap['BasvuruKullaniciKod']"
        [controlName]="'GenKullanici'"
        (dataResult)="helpdeskForm.BasvuruKullaniciKod = $event.Kod"
        [labelMode]="labelMode"
        [isReadOnly]="true"
      ></dk-ctl-gen-kontrol>
    </div>
  </dxi-item>
  <dxi-item
    dataField="BasvuruKullaniciKod"
    [label]="{ text: 'Birim' }"
    [editorOptions]="{
        readOnly: true,
      }"
  >
    <div *dxTemplate>
      <dk-ctl-gen-kontrol
              #control

        [labelText]="'Birim'"
        [code]="helpdeskForm?.BasvuruKullaniciKod"
        [validationRulesMap]="validationRulesMap['BasvuruKullaniciKod']"
        [controlName]="'GenBirimGenel'"
        (dataResult)="helpdeskForm.BasvuruKullaniciKod = $event.Kod"
        [labelMode]="labelMode"
        [isReadOnly]="true"
      ></dk-ctl-gen-kontrol>
    </div>
  </dxi-item>

  <dxi-item dataField="Oncelik" [label]="{ text: 'Öncelik' }">
    <div *dxTemplate>
      <dk-ct-gen-lookup
        [validationRules]="validationRulesMap['Oncelik']"
        [placeholder]="'Öncelik'"
        [selectedValue]="helpdeskForm?.Oncelik"
        (valueChange)="helpdeskForm.Oncelik = $event.value"
        [readOnly]="!editMode && state !== 'New'"
        [lookUpType]="'HLP_ONCELIK_TUR'"
        [labelMode]="labelMode"
        [label]="'Öncelik'"
      ></dk-ct-gen-lookup>
    </div>
  </dxi-item>

  <dxi-item
    dataField="FormKod"
    [label]="{ text: 'Form' }"
    [editorOptions]="{
        readOnly: true,
      }"
  >
    <div *dxTemplate>
      <dk-ctl-gen-kontrol
              #control

        [labelText]="'Form '"
        [code]="helpdeskForm?.FormKod"
        [validationRulesMap]="validationRulesMap['FormKod']"
        [controlName]="'GenForm'"
        (dataResult)="helpdeskForm.FormKod = $event.Kod"
        [labelMode]="labelMode"
        [isReadOnly]="true"
      ></dk-ctl-gen-kontrol>
    </div>
  </dxi-item>
  <dxi-item
    dataField="SubFormAd"
    [label]="{ text: 'Alt Form' }"
    [editorOptions]="{
        readOnly: true,
      }"
  >
    <div *dxTemplate>
      <dk-ctl-gen-kontrol
              #control

        [labelText]="'Alt Form'"
        [code]="helpdeskForm?.SubFormAd"
        [validationRulesMap]="validationRulesMap['SubFormAd']"
        [controlName]="'GenForm'"
        (dataResult)="helpdeskForm.SubFormAd = $event.Kod"
        [labelMode]="labelMode"
      ></dk-ctl-gen-kontrol>
    </div>
  </dxi-item>

  <dxi-item dataField="KategoriKod" [label]="{ text: 'Talep Konusu' }">
    <div *dxTemplate>
      <dk-ct-gen-lookup
        [validationRules]="validationRulesMap['KategoriKod']"
        [placeholder]="'Talep Konusu'"
        [selectedValue]="helpdeskForm?.KategoriKod"
        (valueChange)="helpdeskForm.KategoriKod = $event.value"
        [readOnly]="!editMode && state !== 'New'"
        [lookUpType]="'HLP_KATEGORI_TUR'"
        [labelMode]="labelMode"
        [label]="'Talep Konusu'"
      ></dk-ct-gen-lookup>
    </div>
  </dxi-item>
  <dxi-item dataField="Baslik" [label]="{ text: 'Başlık' }"> </dxi-item>
  <dxi-item
    dataField="Detay"
    [label]="{ text: 'Talep Detay' }"
    editorType="dxTextArea"
    [editorOptions]="{
      height: 200,
      showClearButton: true,
      maxLength: 1000
    }"
  ></dxi-item>
  <dxi-item dataField="EmailEh" [label]="{ text: 'E-Mail' }">
    <div *dxTemplate>
      <dk-ct-gen-radio-btn
    [lookUpType]="'GEN_EVETHAYIR'"
    [dataField]="'EmailEh'"
    [value]="helpdeskForm?.EmailEh"
    (valueChange)="helpdeskForm.EmailEh = $event"
    [validationRules]="validationRulesMap['EmailEh']"
    [readOnly]="!editMode && state !== 'New'"
></dk-ct-gen-radio-btn>
    </div>
  </dxi-item>
  <dxi-item dataField="SmsEh" [label]="{ text: 'SMS' }">
    <div *dxTemplate>
       <dk-ct-gen-radio-btn
    [lookUpType]="'GEN_EVETHAYIR'"
    [dataField]="'SmsEh'"
    [value]="helpdeskForm?.SmsEh"
    (valueChange)="helpdeskForm.SmsEh = $event"
    [validationRules]="validationRulesMap['SmsEh']"
    [readOnly]="!editMode && state !== 'New'"
></dk-ct-gen-radio-btn>
    </div>
  </dxi-item>
</dx-form>
<dx-toolbar class="bottomSaveCancelBtn">
  <dxi-item location="after">
    <dx-button
      stylingMode="contained"
      type="danger"
      text="İptal"
      (onClick)="handleCancelClick()"
    ></dx-button>
  </dxi-item>
  <dxi-item location="after">
    <dx-button
      stylingMode="contained"
      type="default"
      text="Kaydet"
      [disabled]="(!editMode && state !== 'New') || isLoading"
      (onClick)="handleSaveClick()"
    ></dx-button>
  </dxi-item>
</dx-toolbar>
-->
<div class="hlp-talep-form">
  <dx-form
    id="form"
    [formData]="helpdeskForm"
    [colCount]="1"
    [showColonAfterLabel]="true"
    [labelMode]="labelMode"
    [labelLocation]="labelLocation"
  >
    <dxi-item
      dataField="FormAd"
      [visible]="!!helpdeskForm?.FormAd"
      [label]="{ text: 'Ekran' }"
      [editorOptions]="{ readOnly: true }"
    ></dxi-item>
    <dxi-item
      dataField="KayitKod"
      [visible]="!!helpdeskForm?.KayitKod"
      [label]="{ text: 'Seçili Kayıt No' }"
      [editorOptions]="{ readOnly: true }"
    ></dxi-item>

    <dxi-item dataField="KategoriKod" [label]="{ text: 'Kategori' }">
      <div *dxTemplate>
        <dk-ct-gen-lookup
          [placeholder]="'Kategori seçiniz'"
          [selectedValue]="helpdeskForm?.KategoriKod"
          (valueChange)="helpdeskForm.KategoriKod = $event?.value"
          [lookUpType]="'HLP_KATEGORI_TUR'"
          [valueExpr]="'kod'"
          [labelMode]="labelMode"
          [label]="'Kategori'"
        ></dk-ct-gen-lookup>
      </div>
    </dxi-item>

    <dxi-item dataField="Oncelik" [label]="{ text: 'Öncelik' }">
      <div *dxTemplate>
        <dk-ct-gen-lookup
          [placeholder]="'Öncelik'"
          [selectedValue]="helpdeskForm?.Oncelik"
          (valueChange)="helpdeskForm.Oncelik = $event?.value"
          [lookUpType]="'HLP_ONCELIK_TUR'"
          [valueExpr]="'kod'"
          [showClearBtn]="false"
          [labelMode]="labelMode"
          [label]="'Öncelik'"
        ></dk-ct-gen-lookup>
      </div>
    </dxi-item>

    <dxi-item
      dataField="Baslik"
      [label]="{ text: 'Konu' }"
      [editorOptions]="{ maxLength: 100, placeholder: 'Sorunu kısaca özetleyin' }"
    ></dxi-item>
    <dxi-item
      dataField="Detay"
      [label]="{ text: 'Açıklama' }"
      editorType="dxTextArea"
      [editorOptions]="{
        height: 180,
        maxLength: 1000,
        placeholder: 'Ne yapmaya çalışıyordunuz, ne oldu, hata mesajı neydi?'
      }"
    ></dxi-item>
  </dx-form>

  <!-- DKM-5193 Cedric: ekler — ekran görüntüsü kullanıcının seçimine bağlı (varsayılan kapalı), hata listesi varsa ekli gelir -->
  <div class="hlp-ekler">
    <div class="hlp-ek">
      <dx-check-box
        text="Ekran görüntüsü ekle"
        [value]="ekranGoruntusuEkle"
        [disabled]="isLoading"
        (onValueChanged)="$event.event && ekranGoruntusuSecimi($event.value)"
      ></dx-check-box>
      <span class="hlp-ek-ipucu">Bu pencerenin arkasındaki ekranın görüntüsü alınır; ekranda kişisel bilgi varsa eklemeyin.</span>
      <div class="hlp-ek-durum" *ngIf="ekranGoruntusuAliniyor">Ekran görüntüsü alınıyor...</div>
      <div class="hlp-ek-durum hata" *ngIf="ekranGoruntusuHata">{{ ekranGoruntusuHata }}</div>
      <img
        *ngIf="ekranGoruntusuEkle && ekranGoruntusu"
        class="hlp-ek-onizleme"
        [class.buyuk]="ekranGoruntusuBuyuk"
        [src]="ekranGoruntusu"
        alt="Ekran görüntüsü önizlemesi"
        title="Büyütmek / küçültmek için tıklayın"
        (click)="ekranGoruntusuBuyuk = !ekranGoruntusuBuyuk"
      />
    </div>

    <div class="hlp-ek" *ngIf="sonHatalar.length">
      <dx-check-box
        [text]="'Bu ekranda alınan son hataları ekle (' + sonHatalar.length + ')'"
        [(value)]="hataListesiEkle"
        [disabled]="isLoading"
      ></dx-check-box>
      <a class="hlp-ek-bag" (click)="hataListesiAcik = !hataListesiAcik">{{ hataListesiAcik ? 'Gizle' : 'Göster' }}</a>
      <div class="hlp-ek-liste" *ngIf="hataListesiAcik" [innerHTML]="hataListesiHtml"></div>
    </div>
  </div>

  <div class="hlp-talep-not">
    Talebiniz önce kurumunuzun Bilgi İşlem birimine iletilir. Durumunu ve cevapları
    "Destek Taleplerim" ekranından izleyebilirsiniz.
  </div>
</div>

<dx-toolbar class="bottomSaveCancelBtn">
  <dxi-item location="after">
    <dx-button
      stylingMode="contained"
      type="danger"
      text="İptal"
      (onClick)="handleCancelClick()"
    ></dx-button>
  </dxi-item>
  <dxi-item location="after">
    <dx-button
      stylingMode="contained"
      type="default"
      text="Gönder"
      [disabled]="isLoading || !yeniKayitHazir || ekranGoruntusuAliniyor"
      (onClick)="handleSaveClick()"
    ></dx-button>
  </dxi-item>
</dx-toolbar>
